var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{staticClass:"plushies-grid-export-action",attrs:{"buttonText":"Export Grid as Excel","isSmall":true,"isPrimary":true,"disabled":_vm.isDisabled,"action":_vm.onExportButtonClick}})}
var staticRenderFns = []

export { render, staticRenderFns }